import { useContext, useState } from "react";
import { InformationCircleIcon } from "@heroicons/react/20/solid";
import ModalExtra from "./ModalExtra";
import { useTranslation } from "react-i18next";
import Image from "./common/Image";
import DOMPurify from "dompurify";
// import { LangContext } from "../context/lang-context";
import { useInfoStore } from "../store/info-store";

function CalendarItem({ data, duration, isChecked, studioName, onChangeFn }) {
  const { t, i18n } = useTranslation();
  // const { locale } = useContext(LangContext);

  const [infoActive, setInfoActive] = useState(false);
  const { courses } = useInfoStore();

  return (
    <li>
      <label
        htmlFor={`select_${data.list_id}`}
        className="tw-flex tw-items-center tw-px-3 tw-py-2 tw-bg-white tw-rounded-xl active:tw-ring-4 active:tw-ring-teal"
      >
        <div className="tw-flex-0 tw-leading-3">
          <p className="tw-font-condensed tw-font-black tw-text-lg tw-uppercase">
            {data.startzeit}
          </p>
          <p className="tw-text-sm tw-text-teal">
            {t("courses.x_minutes", {
              x: duration,
            })}
          </p>
        </div>
        <div className="tw-flex-1 tw-ml-6">
          <div className="tw-flex tw-items-center">
            <h3 className="tw-font-condensed tw-font-black tw-text-lg tw-uppercase">
              {data.name}
            </h3>
            <button
              className="tw-text-teal/25 tw-ml-1"
              onClick={() => setInfoActive(true)}
            >
              <InformationCircleIcon className="tw-text-grey-medium tw-w-4 tw-h-4" />
            </button>
          </div>
          <p className="tw-text-sm">{studioName}</p>
        </div>
        <div className="tw-flex-0 tw-ml-4">
          <p className="tw-text-sm tw-whitespace-pre-line tw-text-right tw-text-teal">
            {t("courses.x_slots", {
              count: data.free,
            })}
          </p>
        </div>
        <div className={`tw-flex-0 tw-flex tw-items-center tw-ml-4 tw-mr-2`}>
          <input
            className={`tw-overflow-hidden tw-w-0 tw-h-0`}
            type="checkbox"
            id={`select_${data.list_id}`}
            checked={isChecked}
            onChange={(event) => onChangeFn(event)}
          />
          <div
            className={`tw-block tw-rounded-full tw-w-3 tw-h-3 tw-ring-2 tw-ring-offset-2 tw-ring-black tw-bg-white tw-transition-colors [input:checked+&]:tw-ring-teal [input:checked+&]:tw-bg-teal`}
          ></div>
        </div>
      </label>
      <ModalExtra
        title={t("course_details")}
        buttons={[
          {
            label: t("select_course"),
            type: "primary",
            action: (event) => {
              onChangeFn(event);
              setInfoActive(false);
            },
          },
        ]}
        isOpen={infoActive}
        closeModal={() => setInfoActive(false)}
        innerClassName="tw-p-5"
      >
        <Image
          className="tw-rounded-2xl tw-overflow-hidden"
          src={courses[data.course_id].image.url}
        />
        <p className="tw-mt-4 tw-font-condensed tw-font-black tw-text-lg tw-uppercase tw-leading-5">
          {courses[data.course_id].name}
        </p>
        <p
          className="tw-mt-3"
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(courses[data.course_id].description),
          }}
        />
      </ModalExtra>
    </li>
  );
}

export default CalendarItem;
